import { getDataMapper, mapField } from "@/shared";

export const mapAuthDataFromServer = getDataMapper({
    accessToken: mapField("access_token"),
    tokenType: mapField("token_type"),
    expires: mapField("expires_at"),
});
